import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, Hammer } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "@/content/ContentContext";
import { ICON_COMPONENTS } from "@/content/serviceIcons";

export const Services = () => {
  const content = useContent();
  const services = content.services;
  const [open, setOpen] = useState(null);

  return (
  <section
    id="leistungen"
    data-testid="services-section"
    className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-40"
  >
    <Reveal>
      <p
        className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-primary"
        data-testid="services-chapter"
      >
        02 · Leistungen
      </p>
      <h2
        className="mb-14 max-w-2xl font-heading text-4xl font-black tracking-tight text-foreground sm:text-5xl md:mb-20"
        data-testid="services-heading"
      >
        Was ich für dich mache.
      </h2>
    </Reveal>

    <div className="border-t border-foreground/10">
      {services.map((s, i) => {
        const IconComp = ICON_COMPONENTS[s.icon] || Hammer;
        const isOpen = open === i;
        return (
        <Reveal key={s.nr} delay={i * 0.06}>
          <div className="border-b border-foreground/10">
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              data-testid={`service-row-${s.nr}`}
              className="group flex w-full items-center gap-6 py-7 text-left transition-colors duration-300 hover:bg-foreground/[0.03] md:gap-10 md:py-9"
            >
              <span className="font-mono text-xs tracking-[0.2em] text-muted-foreground transition-colors duration-300 group-hover:text-primary md:text-sm">
                {s.nr}
              </span>
              <span
                className="hidden h-12 w-12 shrink-0 items-center justify-center border border-foreground/15 text-muted-foreground transition-colors duration-300 group-hover:border-primary group-hover:text-primary sm:flex md:h-14 md:w-14"
                data-testid={`service-icon-${s.nr}`}
              >
                <IconComp className="h-5 w-5 md:h-6 md:w-6" />
              </span>
              <span className="flex-1">
                <span className="block font-heading text-2xl font-black tracking-tight text-foreground transition-transform duration-300 group-hover:translate-x-2 sm:text-3xl md:text-4xl">
                  {s.title}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                <span className="hidden md:inline">{isOpen ? "Weniger" : "Mehr"}</span>
                <ChevronDown
                  className={`h-6 w-6 transition-[transform,color] duration-300 group-hover:text-primary md:h-7 md:w-7 ${isOpen ? "rotate-180 text-primary" : ""}`}
                />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                  className="overflow-hidden"
                >
                  <p
                    className="max-w-xl pb-8 text-sm leading-relaxed text-muted-foreground md:text-base"
                    data-testid={`service-desc-${s.nr}`}
                  >
                    {s.desc}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </Reveal>
        );
      })}
    </div>

    <Reveal delay={0.1}>
      <p className="mt-10 font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground md:text-sm">
        Was fehlt? Frag einfach – ich sag dir ehrlich, ob ich's kann.
      </p>
    </Reveal>
  </section>
  );
};
